import { ScheduleBaseModel } from '../models/schedule';

export const scheduleFormDefaultValue: ScheduleBaseModel = {
  day: 0,
  timeFrom: null,
  timeTo: null,
};

export const dayOptions = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const allDayOptions = [...dayOptions, 'Every day'];
export const everyDayIndex = dayOptions.length;
